import React from "react"

const CarouselSlide = props => {
  return (
    <div className="carousel__slide">
      <div className="carousel__slide-text">{props.children}</div>
      <p className="carousel__slide-cite">{props.author}</p>
    </div>
  )
}

export default CarouselSlide
